import { apiService } from "../../app.service";

export const restaruantapi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchTemperatureData: builder.query({
      query: () => ({
        url: "/user/temperatureSetting",
      }),
      providesTags: ["temperatures"],
    }),
    fetchOneTemperatureData: builder.query({
      query: (data) => ({
        url: "/user/temperatureSetting/" + data,
      }),
      providesTags: (result) =>
        result ? [{ type: "temperature", id: result._id }] : [],
    }),
    addTemperatureData: builder.mutation({
      query: (data) => ({
        url: "/user/temperatureSetting",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["temperatures"],
    }),
    updateOneTemperatureData: builder.mutation({
      query: (data) => ({
        url: "/user/temperatureSetting/" + data.uid,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "temperature", id },
        "temperatures",
      ],
    }),
    deleteOneTemperatureData: builder.mutation({
      query: (data) => ({
        url: "/user/temperatureSetting/" + data,
        method: "DELETE",
      }),
      invalidatesTags: ["temperatures"],
    }),

    fetchSensorData: builder.mutation({
      query: (data) => ({
        url: "user/sensor/" + data,
        method: "GET",
      }),
    }),

    fetchSensorLatestTempByRestaurant: builder.query({
      query: () => ({
        url: `user/latest-temperatures`,
      }),
    }),
  }),
});

export const {
  useAddTemperatureDataMutation,
  useFetchTemperatureDataQuery,
  useFetchOneTemperatureDataQuery,
  useUpdateOneTemperatureDataMutation,
  useDeleteOneTemperatureDataMutation,
  useFetchSensorDataMutation,
  useFetchSensorLatestTempByRestaurantQuery,
} = restaruantapi;
